import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { BadgeComponent, HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-quick-insight',
  imports: [CommonModule, TranslatePipe, BadgeComponent, HeadingComponent],
  templateUrl: './evaluation-quick-insight.component.html',
  styleUrl: './evaluation-quick-insight.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvaluationQuickInsightComponent {
  public insightQuickContent = input<string>();
}
